import { uniqueId } from "library/database/split-id.mjs"
import { isEnabled } from "lib/@components/feature"
import { getTreeIndex } from "routes/schedule/lib/getTreeIndex"
import { getRegisterTypeId } from "routes/asset-register/plugins/asset-mapping/server/get-register-type-id.mjs"
import { recordMappingFeedback } from "routes/asset-register/plugins/asset-mapping/plugins/ai-mapping-feedback/controller/record-mapping-feedback"
import { FEATURE_FLAG_AI_MAPPING_FEEDBACK } from "routes/asset-register/plugins/asset-mapping/plugins/ai-mapping-feedback/feature-flag-ai-mapping-feedback"

export function recordSelection({ register, entry, cleared = false }) {
    if (!isEnabled(FEATURE_FLAG_AI_MAPPING_FEEDBACK)) return
    if (!register || !entry?.name) return

    const assetTypeId = getRegisterTypeId(register.id, entry.name)
    const { feedbackAttemptId } = entry
    const runId = register.mappingRunId
    if (!feedbackAttemptId && !runId) return

    const selections = cleared ? [] : deriveSelections()
    recordMappingFeedback({
        runId,
        feedbackAttemptId,
        registerId: register.id,
        assetTypeId,
        assetType: entry.name,
        selections,
        excludedByUser: !cleared && entry.doNotMap === "nothing",
        decision: decisionKind(),
    }).catch(console.error)

    function decisionKind() {
        if (cleared) return "cleared"
        if (entry.doNotMap === "nothing") return "excluded"
        return selections.length ? "selected" : "cleared"
    }

    function deriveSelections() {
        if (entry.doNotMap === "create") {
            return manuallySelectedIds().map((id) => selection(id, "manual-search"))
        }
        return (entry.schedules ?? []).filter((s) => s.chosen).map(aiSelection)
    }

    function manuallySelectedIds() {
        const manual = Array.isArray(entry.schedule_ids_manual) ? entry.schedule_ids_manual : []
        return Array.from(new Set([...manual, entry.schedule_id].filter(Boolean)))
    }

    function aiSelection({ schedule_id }) {
        return selection(schedule_id, "ai-suggestion")
    }

    function selection(id, source) {
        const scheduleId = uniqueId(id)
        const treeItem = getTreeIndex().retrieve(id)
        return { scheduleId, scheduleTitle: treeItem?.label ?? scheduleId, source }
    }
}
